import { performRequest} from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const { GET_RESTURANTS_DETAILS, 
            ADD_RESTURANTS_DETAILS,
            UPDATE_RESTURANTS_DETAILS,
            DELETE_RESTURANTS_DETAILS } = URLS;
    return {
        getResturantsDetails: (body={}, method='get') =>
         performRequest( method ? method:'post', GET_RESTURANTS_DETAILS, body ),
        addResturantsDetails: (body={}, method='post') =>
         performRequest( method ? method:'post', ADD_RESTURANTS_DETAILS, body ),
        updateResturantsDetails: (body={}, method='put') =>
         performRequest( method ? method:'put', UPDATE_RESTURANTS_DETAILS, body ),
        deleteResturantsDetails: (body={}, method='delete') =>
         performRequest( method ? method:'delete', DELETE_RESTURANTS_DETAILS, body )

    }
}